import FormField from 'components/FormField';
import { FV } from './share';
import { InputNumber } from 'antd';
import { isNil } from 'lodash-es';
import { useTranslate } from '@tolgee/react';
import { DisabledProps } from 'views/Aide/Scenario/TaskForm/share';
import { useHelpContext } from '../HelpContext';
import { InlineHelp } from '../Help';

function MaxDiscount({ readonly, disabled }: { readonly?: boolean } & DisabledProps) {
  const { t } = useTranslate();

  const {
    stepState: [, setHelpStep],
  } = useHelpContext();

  return (
    <FormField<FV['maxDiscount']> name="maxDiscount" label={t('act_field_discount')}>
      {({ field: { value, onChange, onBlur } }) => {
        if (readonly) {
          return `${value}%off`;
        }

        const input = (
          <InputNumber
            disabled={disabled}
            placeholder={t('trade.请输入')}
            value={value ? Number(value) : null}
            onChange={(value) => onChange(isNil(value) ? undefined : `${value}`)}
            onBlur={onBlur}
            addonAfter="%off"
            precision={0}
            min={1}
            max={99}
            onFocus={() => setHelpStep('最高折扣')}
          />
        );

        return (
          <InlineHelp step="最高折扣">
            <span>{input}</span>
          </InlineHelp>
        );
      }}
    </FormField>
  );
}

export default MaxDiscount;
